import React from 'react'
import { useState } from 'react'
import {useAuthContext} from './useAuthContext'

export const useSignup = () => {
    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(null)
    const {dispatch} = useAuthContext()

    const signup = async (username, fullName, email, password, password2) =>{
        setIsLoading(true)
        setError(null)

        console.log(username, fullName, email, password, password2)
        const fd = {
            "username": username,
            "full_name": fullName,
            "email": email,
            "password": password,
            "password2": password2
        };
        console.log(fd)
        
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/admin-register/`, {
            method: 'POST',
            body: JSON.stringify(fd),
            headers: {'Content-Type': 'application/json'}
        })

        const json = await response.json()

        if(!response.ok){
            setIsLoading(false)
            setError(json.error)
        }

        if(response.ok){
            // save the user to local storare
            localStorage.setItem('user', JSON.stringify(json))

            //update the auth context
            dispatch({type: 'LOGIN', payload: json})
            setError(false)
            setIsLoading(false)
        }

    }
    return {signup, isLoading, error}
}

export default useSignup